import React, { useState, useEffect } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import ListLists from '../../Services/Queries/ListLists'
import RemoveFromList from '../../Services/Mutations/RemoveFromList'

import GetConfiguredDetails from '../../Services/Queries/GetConfiguredDetails'

import AddToList from '../../Services/Mutations/AddToList'
class AddContentToListAction extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			listModalVisible: false,
			contentMainCategory: 'news',
			currentUserDetails: {},
			searchQuery: '',
			listOfLists: [],
			limit: 20,
			nextToken: null,
			endReached: false,
			spinner: true,
			selectedList: {},
			modalVisible: false,
			sectionLabel_Te: '',
			sectionLabel_Hi: '',
			sectionLabel_En: '',
			isMainList: false,
			sortType: 'date',
			selectedSectionColumns: '1',
			selectedSectionScroll: 'horizontal',
			addingNewItemsTo: 0,
			showAsSubPage: false,
			showAfter: '',
			pagesData: [],
			contentInData: [],
			listToDelete: {},
			removeFromListModalVisible: false,
			addedListsIdsArr: [],
		}
	}
	getListLists = async (searchQuery) => {
		const input = {
			limit: this.state.limit,
			appInfoFrontEnd: {
				appVersionNumber: 60,
				UUID: Auth.user.username,
			},
		}
		if (searchQuery) {
			input.search = searchQuery
		}
		const data = await ListLists(input)

		this.setState({
			listOfLists: data.items,
			nextToken: data.nextToken,
			spinner: false,
			endReached: data.nextToken != null ? false : true,
		})
	}
	onChangeSearch = (searchQuery) => {
		this.setState({ searchQuery: searchQuery })
		this.getListLists(searchQuery)
	}
	openListModal = async () => {
		await this.getListLists()
		await this.getConfiguredDetails()
		this.setState({ listModalVisible: true, selectedList: {} })
	}

	closeListModal = () => {
		this.setState({
			listModalVisible: false,
			searchQuery: '',
		})
	}
	closeRemoveModal = () => {
		this.setState({
			removeFromListModalVisible: false,
			listToDelete: {},
		})
	}
	removeContentFromList = async () => {
		const { listToDelete } = this.state
		console.log(listToDelete, 'listToDelete')
		this.setState({ removeFromListModalVisible: false })
		const input = {
			type: 'content',
			listValue: listToDelete.listValue,
			contentID: this.props.item.PK,

			appInfoFrontEnd: {
				appVersionNumber: 60,
				UUID: Auth.user.username,
			},
		}
		console.log(input, 'inputttttt')
		const data = await RemoveFromList(input)
		console.log(data, 'dataaaa')
		if (data.statusCode == 'A251') {
			const index = this.state.contentInData.findIndex(
				(list) => list.listValue == this.state.listToDelete.listValue
			)
			const contentInData = this.state.contentInData
			contentInData.splice(index, 1)

			const index2 = this.state.addedListsIdsArr.findIndex(
				(listValue) => listValue == this.state.listToDelete.listValue
			)
			const addedListsIdsArr = this.state.addedListsIdsArr
			addedListsIdsArr.splice(index2, 1)

			this.props.displayToast('success', 'Removed Content From List Successfully')

			this.setState({
				contentInData: contentInData,
				addedListsIdsArr: addedListsIdsArr,
			})
		} else {
			this.props.displayToast('error', 'Failed to Remove Content From List')
		}
	}
	addContentToList = async () => {
		let loggedInUserHandle = ''
		const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
		if (loggedInUserEmail) {
			const emailParams = loggedInUserEmail.split('@')
			loggedInUserHandle = '@' + emailParams[0]
		}
		const input = {
			type: 'content',
			listValue: this.state.selectedList.listValue,
			addedToListByUUID: Auth.user.username,
			addedToListByHandle: loggedInUserHandle,
			contentID: this.props.item.PK,
		}
		this.closeListModal()
		try {
			const data = await AddToList(input)

			if (data.statusCode == 'A250') {
				this.props.displayToast('success', 'Added Content To List Successfully')
			} else {
				this.props.displayToast('error', 'Failed to Added Content To List')
			}
		} catch (error) {
			return error
		}
	}

	getMoreLists = async () => {
		const { endReached, limit, nextToken } = this.state
		if (!endReached) {
			const input = {
				limit: limit,
				nextToken: nextToken,
				appInfoFrontEnd: {
					appVersionNumber: 60,
					UUID: Auth.user.username,
				},
			}
			const data = await ListLists(input)
			this.setState({
				listOfLists: [...this.state.listOfLists, ...data.items],
				nextToken: data.nextToken,
				endReached: data.nextToken != null ? false : true,
			})
		}
	}
	selectList = (selectedList) => {
		this.setState({ selectedList: selectedList })
	}
	loadMore = async () => {
		await this.getMoreLists()
	}
	getListName = (item) => {
		return item.listName
			? item.listName
			: item.listName_En
				? item.listName_En
				: item.listName_Hi
					? item.listName_Hi
					: item.listName_Te
						? item.listName_Te
						: item.listName
	}
	_rowRenderer(item) {
		const backgroundColor = this.state.selectedList.listValue == item.listValue ? '#999999' : null
		return (
			<div>
				<div
					style={{ marginBottom: '5px', backgroundColor: backgroundColor }}
					onClick={() => {
						this.selectList(item)
					}}
				>
					<img
						style={{ width: '30px', height: '30px', borderRadius: '20px', marginRight: '5px' }}
						src={item.listThumbnail}
					/>
					<text>{this.getListName(item)}</text>
				</div>
			</div>
		)
	}
	_addedRowRenderer(item) {
		return (
			<div>
				<div style={{ marginBottom: '5px', display: 'flex' }}>
					<img
						style={{ width: '30px', height: '30px', borderRadius: '20px', marginRight: '5px' }}
						src={item.listThumbnail}
					/>
					<text>{this.getListName(item)}</text>
					<div
						style={{ width: '25px', marginRight: '5px' }}
						onClick={() => {
							this.setState({
								removeFromListModalVisible: true,
								listToDelete: item,
							})
						}}
					>
						<i class='fas fa-trash' />
					</div>
				</div>
			</div>
		)
	}
	getConfiguredDetails = async () => {
		const input = {
			PK: this.props.item.PK,
		}
		try {
			const data = await GetConfiguredDetails(input)
			if (data.length) {
				const pagesData = []
				const contentInData = []
				const addedListsIdsArr = []
				data.map((item) => {
					if (item) {
						if (item.listValue) {
							contentInData.push(item)
							addedListsIdsArr.push(item.listValue)
						} else if (item.pageValue) {
							pagesData.push(item)
						}
					}
				})
				this.setState({
					spinner: false,
					configuredDetails: true,
					pagesData,
					contentInData,
					addedListsIdsArr,
				})
			} else {
				this.setState({
					spinner: false,
					configuredDetails: false,
				})
			}
		} catch {
			this.setState({
				spinner: false,
				configuredDetails: false,
			})
		}
	}

	// componentDidMount() {
	//   setTimeout(() => {
	//     this.getConfiguredDetails()
	//   }, 1000)
	// }
	renderListModal = () => {
		const { listModalVisible, listOfLists, contentInData, addedListsIdsArr } = this.state

		return (
			<Modal show={listModalVisible} onHide={() => this.closeListModal()}>
				<Modal.Body>
					<div className='row'>
						{contentInData && contentInData.length > 0 ? (
							<div class='row'>
								<label>Content Added To</label>
							</div>
						) : null}

						{contentInData.map((list, index) => {
							return <div key={index}>{this._addedRowRenderer(list)}</div>
						})}
					</div>
					<label>Search List:</label>
					<input
						type='text'
						onChange={(e) => {
							this.onChangeSearch(e.target.value)
						}}
						value={this.state.searchQuery}
						placeholder='Enter List Name'
					></input>
					<div className='row'>
						<div class='row'>
							<label>Choose List</label>
						</div>

						{listOfLists.map((list, index) => {
							return !addedListsIdsArr.includes(list.listValue) ? (
								<div key={index}>{this._rowRenderer(list)}</div>
							) : null
						})}
					</div>
					{this.state.nextToken != null ? (
						<button onClick={() => this.loadMore()}>Load More</button>
					) : null}
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeListModal()}>Cancel</Button>
					{Object.keys(this.state.selectedList).length > 0 ? (
						<Button onClick={() => this.addContentToList()}>Add Content To List</Button>
					) : (
						<Button disabled>Add Content To List</Button>
					)}
				</Modal.Footer>
			</Modal>
		)
	}
	renderDeleteModal = () => {
		const { removeFromListModalVisible, listToDelete } = this.state

		return (
			<Modal show={removeFromListModalVisible} onHide={() => this.closeRemoveModal()}>
				<Modal.Body>
					<div className='row'>
						<div class='row'>
							<label>Are you sure you want to remove content from this list?</label>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeRemoveModal()}>Cancel</Button>
					{Object.keys(this.state.listToDelete).length > 0 ? (
						<Button onClick={() => this.removeContentFromList()}>Remove</Button>
					) : (
						<Button disabled>Remove</Button>
					)}
				</Modal.Footer>
			</Modal>
		)
	}
	render() {
		return (
			<>
				{this.props.rank ? (
					<div
						class={this.props.rank ? '' : 'col-md-3 faIconClass'}
						onClick={() => {
							this.openListModal()
						}}
					>
						<label>Add Content To List</label>
					</div>
				) : (
					<div
						data-toggle='tooltip'
						title={`Add Content To List`}
						style={{ fontSize: '12px' }}
						class={this.props.rank ? '' : 'col-md-3 faIconClass'}
						onClick={() => {
							this.openListModal()
						}}
					>
						<i class='fas fa-list-ul fa-lg' />
					</div>
				)}

				{this.renderListModal()}
				{this.renderDeleteModal()}
			</>

		)
	}
}

export default AddContentToListAction
